/**
 * Product Page State Availability Badge (Notaries.com)
 * =======================================
 * Shows availability for the customer's selected state.
 * When a state is selected, the dropdown is always visible below the badge.
 * When no state is selected, just shows the picker with a prompt.
 */

(function() {
  'use strict';

  var STATE_KEY = 'noa_selected_state';

  var ALL_STATES = [
    { abbr: 'AL', name: 'Alabama' },
    { abbr: 'AK', name: 'Alaska' },
    { abbr: 'AZ', name: 'Arizona' },
    { abbr: 'AR', name: 'Arkansas' },
    { abbr: 'CA', name: 'California' },
    { abbr: 'CO', name: 'Colorado' },
    { abbr: 'CT', name: 'Connecticut' },
    { abbr: 'DE', name: 'Delaware' },
    { abbr: 'FL', name: 'Florida' },
    { abbr: 'GA', name: 'Georgia' },
    { abbr: 'HI', name: 'Hawaii' },
    { abbr: 'ID', name: 'Idaho' },
    { abbr: 'IL', name: 'Illinois' },
    { abbr: 'IN', name: 'Indiana' },
    { abbr: 'IA', name: 'Iowa' },
    { abbr: 'KS', name: 'Kansas' },
    { abbr: 'KY', name: 'Kentucky' },
    { abbr: 'LA', name: 'Louisiana' },
    { abbr: 'ME', name: 'Maine' },
    { abbr: 'MD', name: 'Maryland' },
    { abbr: 'MA', name: 'Massachusetts' },
    { abbr: 'MI', name: 'Michigan' },
    { abbr: 'MN', name: 'Minnesota' },
    { abbr: 'MS', name: 'Mississippi' },
    { abbr: 'MO', name: 'Missouri' },
    { abbr: 'MT', name: 'Montana' },
    { abbr: 'NE', name: 'Nebraska' },
    { abbr: 'NV', name: 'Nevada' },
    { abbr: 'NH', name: 'New Hampshire' },
    { abbr: 'NJ', name: 'New Jersey' },
    { abbr: 'NM', name: 'New Mexico' },
    { abbr: 'NY', name: 'New York' },
    { abbr: 'NC', name: 'North Carolina' },
    { abbr: 'ND', name: 'North Dakota' },
    { abbr: 'OH', name: 'Ohio' },
    { abbr: 'OK', name: 'Oklahoma' },
    { abbr: 'OR', name: 'Oregon' },
    { abbr: 'PA', name: 'Pennsylvania' },
    { abbr: 'RI', name: 'Rhode Island' },
    { abbr: 'SC', name: 'South Carolina' },
    { abbr: 'SD', name: 'South Dakota' },
    { abbr: 'TN', name: 'Tennessee' },
    { abbr: 'TX', name: 'Texas' },
    { abbr: 'UT', name: 'Utah' },
    { abbr: 'VT', name: 'Vermont' },
    { abbr: 'VA', name: 'Virginia' },
    { abbr: 'WA', name: 'Washington' },
    { abbr: 'WV', name: 'West Virginia' },
    { abbr: 'WI', name: 'Wisconsin' },
    { abbr: 'WY', name: 'Wyoming' },
    { abbr: 'DC', name: 'Washington D.C.' }
  ];

  function injectStyles() {
    if (document.getElementById('noa-badge-styles')) return;
    var css = [
      '@keyframes noa-badge-in { from{opacity:0;transform:translateY(-4px)} to{opacity:1;transform:translateY(0)} }',

      '#noa-product-state-badge { margin:12px 0 16px; font-family:inherit; }',

      '.noa-avail-badge {',
      '  display:flex; align-items:center; gap:12px;',
      '  border-radius:8px 8px 0 0;',
      '  padding:12px 16px;',
      '  animation:noa-badge-in .25s ease both;',
      '}',
      '.noa-avail-badge.noa-standalone { border-radius:8px; }',
      '.noa-available   { background:#eaf5ea; border:1px solid #b8ddb8; border-bottom:none; }',
      '.noa-unavailable { background:#fcebeb; border:1px solid #f09595; border-bottom:none; }',
      '.noa-no-state    { background:#f0f4fa; border:1px solid #c8d4e8; border-radius:8px 8px 0 0; border-bottom:none; }',

      '.noa-badge-icon { width:32px; height:32px; border-radius:50%; display:flex; align-items:center; justify-content:center; flex-shrink:0; }',
      '.noa-available   .noa-badge-icon { background:#2e6b2e; }',
      '.noa-unavailable .noa-badge-icon { background:#a32d2d; }',
      '.noa-no-state    .noa-badge-icon { background:#1a3a6b; }',

      '.noa-badge-text { flex:1; min-width:0; }',
      '.noa-badge-main { font-size:14px; font-weight:600; line-height:1.3; }',
      '.noa-available   .noa-badge-main { color:#1a4a1a; }',
      '.noa-unavailable .noa-badge-main { color:#6b1a1a; }',
      '.noa-no-state    .noa-badge-main { color:#1a3a6b; }',

      '.noa-badge-sub { font-size:12px; margin-top:2px; line-height:1.3; }',
      '.noa-available   .noa-badge-sub { color:#2e6b2e; }',
      '.noa-unavailable .noa-badge-sub { color:#993c3c; }',
      '.noa-no-state    .noa-badge-sub { color:#4a6080; }',

      /* Picker — always shown below badge, joined visually */
      '.noa-state-picker {',
      '  display:flex; align-items:center; gap:8px; flex-wrap:wrap;',
      '  padding:10px 16px 12px;',
      '  border-radius:0 0 8px 8px;',
      '  border:1px solid #c8d4e8; border-top:none;',
      '  background:#fff;',
      '}',
      '.noa-available   + .noa-state-picker { border-color:#b8ddb8; }',
      '.noa-unavailable + .noa-state-picker { border-color:#f09595; }',

      '.noa-state-picker label { font-size:12px; color:#555; white-space:nowrap; flex-shrink:0; }',

      '.noa-state-picker select {',
      '  flex:1 1 160px;',
      '  padding:6px 12px;',
      '  border:1.5px solid #c8d4e8;',
      '  border-radius:6px;',
      '  font-size:14px;',
      '  color:#1a3a6b;',
      '  background:#f4f7fb;',
      '  cursor:pointer;',
      '  outline:none;',
      '  appearance:none; -webkit-appearance:none;',
      '}',
      '.noa-state-picker select:focus { border-color:#1a3a6b; background:#fff; }',
    ].join('\n');

    var style = document.createElement('style');
    style.id = 'noa-badge-styles';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function parseTags(tagsStr) {
    var inc = [], exc = [];
    if (!tagsStr) return { include: inc, exclude: exc };
    tagsStr.split(',').forEach(function(tag) {
      tag = tag.trim().toUpperCase();
      var m1 = tag.match(/^STATE-([A-Z]{2})$/);
      var m2 = tag.match(/^EXCLUDE-([A-Z]{2})$/);
      if (m1) inc.push(m1[1]);
      if (m2) exc.push(m2[1]);
    });
    return { include: inc, exclude: exc };
  }

  function productAvailableForState(tagsStr, state) {
    var p = parseTags(tagsStr);
    if (!p.include.length && !p.exclude.length) return true;
    if (p.include.length) return p.include.indexOf(state) !== -1;
    if (p.exclude.length) return p.exclude.indexOf(state) === -1;
    return true;
  }

  function getStateName(abbr) {
    var s = ALL_STATES.filter(function(s){ return s.abbr === abbr; })[0];
    return s ? s.name + ' (' + abbr + ')' : abbr;
  }

  function buildStateSelect(currentState) {
    var opts = '<option value="">— Select a state —</option>';
    ALL_STATES.forEach(function(s) {
      var sel = s.abbr === (currentState || '').toUpperCase() ? ' selected' : '';
      opts += '<option value="' + s.abbr + '"' + sel + '>' + s.name + ' (' + s.abbr + ')</option>';
    });
    return '<select id="noa-inline-select" aria-label="Select your state">' + opts + '</select>';
  }

  var checkSVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
  var xSVG     = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
  var mapSVG   = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6l6-3 6 3 6-3v15l-6 3-6-3-6 3V6z"/><line x1="9" y1="3" x2="9" y2="18"/><line x1="15" y1="6" x2="15" y2="21"/></svg>';

  function render(mount, tagsStr) {
    var state = '';
    try { state = sessionStorage.getItem(STATE_KEY) || ''; } catch(e) {}

    var badge = '';
    var picker = [
      '<div class="noa-state-picker">',
        '<label>Change state:</label>',
        buildStateSelect(state),
      '</div>',
    ].join('');

    if (!state) {
      badge = [
        '<div class="noa-avail-badge noa-no-state">',
          '<div class="noa-badge-icon">' + mapSVG + '</div>',
          '<div class="noa-badge-text">',
            '<div class="noa-badge-main">Select your state</div>',
            '<div class="noa-badge-sub">See if this product is available where you are</div>',
          '</div>',
        '</div>',
      ].join('');
    } else {
      var available = productAvailableForState(tagsStr, state.toUpperCase());
      var stateName = getStateName(state.toUpperCase());

      if (available) {
        badge = [
          '<div class="noa-avail-badge noa-available">',
            '<div class="noa-badge-icon">' + checkSVG + '</div>',
            '<div class="noa-badge-text">',
              '<div class="noa-badge-main">Available in ' + stateName + '</div>',
              '<div class="noa-badge-sub">This product is available for your state</div>',
            '</div>',
          '</div>',
        ].join('');
        picker = [
          '<div class="noa-state-picker" style="border-color:#b8ddb8;">',
            '<label>Change state:</label>',
            buildStateSelect(state),
          '</div>',
        ].join('');
      } else {
        badge = [
          '<div class="noa-avail-badge noa-unavailable">',
            '<div class="noa-badge-icon">' + xSVG + '</div>',
            '<div class="noa-badge-text">',
              '<div class="noa-badge-main">Not available in ' + stateName + '</div>',
              '<div class="noa-badge-sub">This product is not offered in your state. <a href="/collections/all/state-' + state.toUpperCase() + '" style="color:#6b1a1a;">View products for your state</a></div>',
            '</div>',
          '</div>',
        ].join('');
        picker = [
          '<div class="noa-state-picker" style="border-color:#f09595;">',
            '<label>Change state:</label>',
            buildStateSelect(state),
          '</div>',
        ].join('');
      }
    }

    mount.innerHTML = badge + picker;

    var select = document.getElementById('noa-inline-select');
    if (select) {
      select.addEventListener('change', function() {
        var val = this.value;
        try { sessionStorage.setItem(STATE_KEY, val); } catch(e) {}
        render(mount, tagsStr);
      });
    }
  }

  function init() {
    var mount = document.getElementById('noa-product-state-badge');
    if (!mount) return;
    injectStyles();
    var tagsStr = mount.getAttribute('data-tags') || '';
    render(mount, tagsStr);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
